// import Highcharts from 'highcharts';
import Highcharts from "../Highcharts";
import HighchartsReact from "highcharts-react-official";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { useState } from "react";
import { useEffect } from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& .highcharts-root": {
        fontFamily: "Poppins !important",
      },
      "& .highcharts-drilldown-axis-label": {
        textDecoration: "none !important",
        fill: "var(--grayLv3) !important",
        fontWeight: "400 !important",
      },
      "& .highcharts-label text": {
        textDecoration: "none !important",
        fill: "var(--grayLv3) !important",
        fontWeight: "500 !important",
      },
    },
  })
);

const initialOptions = {
  lang: {
    drillUpText: "{series.name}",
  },
  chart: {
    type: "column",
  },
  credits: {
    enabled: false,
  },
  title: {
    text: "",
    align: "center",
    x: 0,
    y: 20,
  },
  accessibility: {
    announceNewData: {
      enabled: true,
    },
  },
  xAxis: {
    type: "category",
  },
  yAxis: {
    title: {
      enabled: true,
      text: "Total",
    },
  },
  legend: {
    enabled: false,
  },
  plotOptions: {
    series: {
      borderWidth: 0,
      dataLabels: {
        enabled: true,
        // format: '{point.y:.1f}%' uma casa decimal + %
        // format: '{point.y:.1f}'  uma casa decimal
        // format: '{point.y:.2f}'  duas casas decimais
      },
    },
  },
  tooltip: {
    headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
    pointFormat:
      '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>',
  },
  series: [],
  drilldown: {
    drillUpButton: {
      position: {
        x: 0,
        y: -42,
      },
    },
    series: [],
  },
};

interface ChartProps {
  data: {
    series: any;
    details: any;
    title: string;
  };
}

export default function ColumnDrillDown({ data }: ChartProps) {
  const [options, setOptions] = useState(initialOptions);
  const classes = useStyles();

  useEffect(() => {
    setOptions({
      ...options,
      series: data.series,
      drilldown: { ...options.drilldown, series: data.details },
      title: { ...options.title, text: data.title },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div className={classes.root}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
